import React from 'react'
import useManageProjectStore from '../../../../../stores/manageProject/useManageProjectStore'
import _ from 'lodash'
import useProjectHook from '../../../shareLogic/useProjectHook'
import { NoticeAdditionalType } from './noticeAdditionalDocument'

type UseResultOfConsiderType = NoticeAdditionalType

// import { fileExt as fileExtConst, topicForLecturer, topicForStudent } from '../../../../../../constants/constants'
const useNoticeAdditional = (props: UseResultOfConsiderType) => {
    const manageProjectStore = useManageProjectStore()
    const projectHook = useProjectHook()

    const projectData = manageProjectStore.projectData

    return {
        projectData,
    }
}

export default useNoticeAdditional
